<template>
  <div class="side-panel-template">
    <div ref="header" class="side-panel-header pt-4" :class="{'top-sticky-blur top-sticky-blur-neutral negative-mx-5 px-5' : stickyHeader, 'd-none-after' : hidePanelTitle}">
      <div class="inner" :class="{'mb-2': stickyHeader && hidePanelTitle}">
        <div class="fx-row-center w-100 no-min-width">
          <slot name="headerIcon" />
          <router-link v-if="backRoute" :to="backRoute" custom v-slot="{ navigate }">
            <a @click="go(navigate, $event)" role="link" class="txt-primary mr-2">
              <svg class="icon-regular" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-arrow-left"></use></svg>
              <span class="back-label">{{ backLabel }}</span>
            </a>
          </router-link>
          <side-panel-title
            v-else-if="topTitle && rename"
            class="mb-none"
            ref="title"
            :error="titleError"
            :error-message="titleErrorMessage"
            @blur="$emit('blurTitle')"
            :show-actions="renameActions"
            :key="$route.fullPath + titleKey"
            :editable="rename" 
            v-model="titleModel" />
          <h3 class="txt-title-small mb-0 txt-bold" v-else-if="topTitle">{{ topTitle }}</h3>
          <h3 class="txt-body txt-muted" v-else-if="hub && !topLabel">{{ hub.title }}</h3>
          <h3 class="txt-title-small mb-0 txt-bold" v-else-if="innerTitle">{{ innerTitle }}</h3>
          <div v-if="topLabel && !backRoute && !hub" class="top-label pt-1 mr-auto" :class="(($route.name === 'LibraryFolder' || $route.params.noBackRoute) && $route.name !== 'MediaPage') ? 'txt-title-small txt-dark mb-0 txt-bold' : 'txt-body txt-muted'">{{topLabel}}</div>
          <div v-else-if="topLabel" class="top-label pt-1 mr-auto txt-body txt-muted">{{topLabel}}</div>
        </div>
        <b-btn variant="icon ml-3" size="sm" @click="closePanel">
          <svg class="icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-cross"></use></svg>
        </b-btn>
      </div>
      <div class="inner" v-if="titleModel && !hidePanelTitle">
        <side-panel-title
          class="mb-auto"
          ref="title"
          :error="titleError"
          :error-message="titleErrorMessage"
          @blur="$emit('blurTitle')"
          :show-actions="renameActions"
          :key="$route.fullPath + titleKey"
          :editable="rename" 
          v-model="titleModel" />
        <slot name="actions"></slot>
      </div>
      <slot name="header"></slot>
    </div>
    <h3 class="txt-title-small mb-0" v-if="topTitle && documents">{{ topTitle }}</h3>
    <p v-if="description" class="txt-body txt-muted mb-2">{{ description }}</p>
    <slot v-else name="description"></slot>
    <div class="side-panel-body">
      <slot></slot>
    </div>
  </div>
</template>
<script>
  import Hub from "@app2/models/Hub";
  import rootRouter from "@app2/router";
  import SidePanelTitle from "@app2/core/Components/Sidepanel/Title";
  import {get} from "lodash";
  import playlistApp from "@app2/modules/Library/Builder/playlist.app";
  import eventBus from "@app2/core/eventBus";

  export default {
    name: 'LibraryBuilderTemplate',
    components: {SidePanelTitle},
    computed: {
      hub() {
        return Hub.find(get(rootRouter, 'currentRoute.params.hash'));
      },
      titleModel: {
        get() { return this.topTitle ? this.topTitle : this.title },
        set(val) { this.$emit('rename', val); },
      },
    },
    props: {
      customClose: {
        type: Boolean,
        default: false
      },
      hidePanelTitle: {
        type: Boolean,
        default: false
      },
      deleteAction: Boolean,
      deleteLabel: String,
      backRoute: {},
      backLabel: {},
      title: {},
      topTitle: {},
      innerTitle: String,
      titleError: Boolean,
      titleKey: {},
      titleErrorMessage: String,
      rename: Boolean,
      renameActions: Boolean,
      topLabel: {},
      hasChanged: Boolean,
      description: {
        type: String
      },
      documents: {
        type: Boolean,
        default: false
      },
      stickyHeader: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      closePanel() {
        this.$emit('close')
        playlistApp.$bvModal.hide('playlist-form-dialog');
      },
      focus() {
        if ( this.$refs.title ) this.$refs.title.focusTitle();
      },
      go(navigate, e) {
        const payload = { navigate, event: e, prevented: false };
        if ( this.$route.name === 'Card' && this.backRoute?.name === 'Cards' ) {
          navigate(e)
          this.$emit('back', payload)
          return;
        }
        if(this.hasChanged) {
          payload.prevented = true;
          eventBus.$emit('media-save-before-close', payload)
        } else {
          navigate(e)
        }
        this.$emit('back', payload)
      }
    },
  }
</script>
